export const HST_UPDATE_STATE = "HST_UPDATE_STATE"
export const CHATLOGS_LOADED = "CHATLOGS_LOADED"
export const MORE_CHATLOGS_LOADED = "MORE_CHATLOGS_LOADED"
export const HST_UPDATE_SELECTED_CHAT = "HST_UPDATE_SELECTED_CHAT"
export const UPDATE_SELCECTED_CHAT_MESSAGE = "UPDATE_SELCECTED_CHAT_MESSAGE"
export const HST_UPDATE_CHATLIST_ITEM = "HST_UPDATE_CHATLIST_ITEM"